import Axios from './config';

export const listClinics = async () =>
    await Axios({
        method: 'GET',
        url: 'clinics'
    });
